import { useQuery } from '@tanstack/react-query'
import config from 'config'
import { ofetch } from 'ofetch'
import { getAuthToken } from 'utils/funcs/browser/getAuthToken'
import { getOrgId } from 'utils/funcs/browser/getOrgId'

export const $fetch = ofetch.create({
  baseURL: config.API_URL,
  retry: false,
  async onRequest({ options }) {
    const headers = options.headers instanceof Headers
      ? Object.fromEntries(options.headers.entries())
      : options.headers || {}

    const authToken = getAuthToken()
    const orgId = getOrgId()

    options.headers = {
      ...Object.fromEntries(
        Object.entries(headers).filter(([key]) =>
          !['authorization', 'auth', 'x-bland-org-id'].includes(key.toLowerCase()),
        ),
      ),
      ...(authToken && { Authorization: authToken }),
      ...(orgId && { 'x-bland-org-id': orgId }),
    }
  },
})

export function useFetch(endpoint, options = {}) {
  const defaultQueryKey = [
    endpoint,
    ...(options.params ? Object.values(options.params) : []),
    ...(options.query ? Object.values(options.query) : []),
  ]

  const {
    queryKey = defaultQueryKey,
    params,
    query,
    headers,
    responseType,
    dataKey = 'data',
    ...queryOptions
  } = options

  return useQuery({
    queryKey,
    queryFn: async () => {
      const response = await $fetch(endpoint, {
        params,
        query,
        headers,
        responseType,
      })
      return response[dataKey] || response
    },
    ...queryOptions,
  })
}
